module.exports = __webpack_public_path__ + "img/HongKongTrust2.cff3725c.png";